// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__BmUou"};